module.exports = __webpack_public_path__ + "assets/img/teacher (37).0961f485.png";